import { z } from 'zod';
/**
 * Contract for end-user feedback on an assistant turn (the accuracy feedback
 * flywheel). Shared by the API route and the web client; rating is data, so no
 * per-message bespoke handler is needed.
 */
export const messageFeedbackRatingSchema = z.enum(['up', 'down']);
export const submitMessageFeedbackSchema = z.object({
    /** External uuid of the assistant chat message being rated. */
    messageUuid: z.string().uuid(),
    rating: messageFeedbackRatingSchema,
    /** Optional free-text correction (seeds a promoted golden eval case). */
    correctionText: z.string().max(4000).optional(),
});
//# sourceMappingURL=ai-feedback.js.map